import { useState } from "react"
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom"

import "./App.css"
import Main from "./components/Main/Main"
import MainLayout from "./components/routes/MainLayout"
import Services from "./components/routes/Services"
import Prices from "./components/routes/Prices"
import Contacts from "./components/routes/Contacts"
import SingleService from "./components/Main/SingleService"
import Question from "./components/Question"
import SingleProduct from "./components/Main/SingleProduct"
import OrderForm from "./components/routes/OrderForm"
import VizitkaPage from "./components/routes/VizitkaPage"

function App() {
  const [language, setLanguage] = useState(true)

  return (
    <BrowserRouter>
      <div className="App font-montserrat tracking-wider">
        <Routes>
          <Route path="/" element={<MainLayout />}>
            <Route index element={<Main />} />
            {/* <Route path="start" element={<Main language={language} />} /> */}
            <Route path="services" element={<Services />} />
            <Route path="prices" element={<Prices />} />
            <Route path="contacts" element={<Contacts />} />
            <Route path="orderform" element={<OrderForm />} />
            <Route
              path="services/:slug"
              element={<SingleService language={language} />}
            />
            <Route
              path="product/wind"
              element={<SingleProduct language={language} />}
            />
            <Route path="vizitka-page" element={<VizitkaPage />} />
          </Route>
        </Routes>
      </div>
    </BrowserRouter>
  )
}

export default App
